import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const OWNER_TOKEN_KEY = "mateo_owner_token";

interface Props {
  children: React.ReactNode;
}

export default function AuthGuard({ children }: Props) {
  const [checking, setChecking] = useState(true);
  const [authenticated, setAuthenticated] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem(OWNER_TOKEN_KEY);
    if (token) {
      setAuthenticated(true);
    } else {
      navigate("/owner/login", { replace: true });
    }
    setChecking(false);
  }, [navigate]);

  if (checking) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background-50">
        <div className="flex flex-col items-center gap-3">
          <i className="ri-loader-4-line text-3xl text-primary-500 animate-spin"></i>
          <span className="text-sm text-foreground-500">Checking access...</span>
        </div>
      </div>
    );
  }

  if (!authenticated) return null;

  return <>{children}</>;
}